import { useQuery } from '@tanstack/react-query'
import { getRosterPlayers } from '../../../services/team/rosterPlayer'
import type { RosterPlayerListItem } from '../../team/player/mapRosterPlayerToForm'

interface UseRosterPlayersOptions {
  teamId?: string | null
  rosterId?: string | null
  /**
   * Off ⇒ the query never runs. The roster-players endpoint is `view`-gated
   * (independent of manageBalance), so the Command Center passes false unless the
   * caller can manage the roster — never fetch a 403 we would only discard.
   */
  enabled?: boolean
}

/**
 * SN-4709 follow-up — the roster's players as full rows (RosterPlayerListItem),
 * the shape the Edit Player editor prefills from. A 403 (no roster view) or any
 * failure resolves to no data with `retry: false`, so the caller degrades to
 * "no Edit Player action" rather than surfacing an error.
 */
export const useRosterPlayers = ({
  teamId,
  rosterId,
  enabled = true,
}: UseRosterPlayersOptions) =>
  useQuery<RosterPlayerListItem[]>({
    queryKey: ['balanceRosterPlayersForEdit', teamId, rosterId],
    queryFn: () => getRosterPlayers(teamId as string, rosterId as string),
    enabled: Boolean(teamId) && Boolean(rosterId) && enabled,
    retry: false,
    staleTime: 30_000,
  })

export default useRosterPlayers
